import React, { useContext } from "react";
import { Outlet, NavLink } from "react-router-dom";
import { AuthContext } from "../context/authContext";
import {
  FaMailBulk,
  FaMountain,
  FaCalendarAlt,
  FaUsers,
  FaStar,
  FaBuilding,
} from "react-icons/fa";
import backgroundImage from "../assets/images/bg.jpg";

const Admin = () => {
  const { user } = useContext(AuthContext);

  return (
    // <div
    //   className="min-h-screen w-full flex flex-col md:flex-row"
    //   style={{
    //     backgroundImage: `url(${backgroundImage})`,
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //     backgroundRepeat: "no-repeat",
    //   }}
    // >
    <div
      className="min-h-screen w-full"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="hidden md:block fixed top-0 left-0 h-screen w-[20vw] bg-white/90 backdrop-blur-md border-r border-gray-200 shadow-xl px-4 py-6 z-50">
        {/* <div className="w-full md:w-[20vw] min-h-screen bg-white/90 backdrop-blur-md border-r border-gray-200 shadow-xl px-4 py-6"> */}
        <div className="text-center mb-10">
          {/* <h1 className="text-3xl font-extrabold text-[#41A4FF]">Admin</h1> */}
          {/* <p className="mt-2 text-sm font-medium text-gray-700">{user.name}</p> */}
        </div>

        <nav className="flex flex-col gap-2">
          {[
            { to: "mail", icon: <FaMailBulk />, label: "Mail Templates" },
            { to: "addtour", icon: <FaMountain />, label: "Add Tour Packages" },
            { to: "tourlist", icon: <FaMountain />, label: "Tour Packages" },
            {
              to: "reservations",
              icon: <FaCalendarAlt />,
              label: "Reservations",
            },
            { to: "users", icon: <FaUsers />, label: "User List" },
            { to: "Reviews", icon: <FaUsers />, label: "Review And Rating" },
            {
              to: "contact-enquiry",
              icon: <FaUsers />,
              label: "User Contact Enquiry",
            },
            {
              to: "category-region",
              icon: <FaStar />,
              label: "Category & Region",
            },
            // { to: "agency-requests", icon: <FaBuilding />, label: "Agency Requests" },

            // Uncomment if needed
            // { to: "reviews", icon: <FaStar />, label: "Reviews & Ratings" },
          ].map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 text-sm font-medium ${
                  isActive
                    ? "bg-[#41A4FF] text-white shadow-md"
                    : "text-gray-700 hover:bg-gray-100"
                }`
              }
            >
              <span className="text-lg">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
      {/* Main Content */}
      <div className="md:ml-[20vw] p-5 bg-white/70 backdrop-blur-md h-screen overflow-y-auto">
        {/* <div className="w-full md:w-[85vw] p-5 bg-white/70 backdrop-blur-md"> */}
        <Outlet />
      </div>
    </div>
  );
};

export default Admin;
